export default class Fixed {
    static init() {
        return new Fixed();
    }

    constructor() {
        this.isFixed = false;
        this.position = 0;

        let classes = ['fixed', 'w-full', 'top-0', 'left-0', 'overflow-hidden', 'pr-[var(--scrollbar-width)]']
        let main = document.querySelector('main');
        let body = document.body;

        window.addEventListener('scroll', () => {
            // calc position
            document.documentElement.style.setProperty('--scroll-y', `-${window.scrollY}px`);
        });

        window.addEventListener('fixed', () => {
            // set fix classes and save position
            this.position = window.scrollY;
            main.style.transform = `translate(0, -${this.position}px)`;
            body.classList.add(...classes);
        });

        window.addEventListener('released', () => {
            // remove fixed classes and scroll to position
            body.classList.remove(...classes);
            window.scrollTo({left: 0, top: parseInt(this.position) || 0, behavior: 'instant'});
            main.style.transform = 'translate(0, 0)';
        });
    }

    fix() {
        this.isFixed = false;
        this.triggerEvent('released', window);
    }

    release() {
        this.isFixed = true;
        this.triggerEvent('fixed', window);
    }

    toggle() {
        this[this.isFixed ? 'fix' : 'release']();
    }

    triggerEvent(eventName, element) {
        let event = new CustomEvent(eventName, {detail: {scrollState: !this.isFixed}});
        element.dispatchEvent(event);
    }
}
